// IMPORTS
// Modules
import { useState, useEffect } from 'react';
// OHS
import { OHSAppHeader, OHSAppBody, OHSAppFooter } from '../../../../onehivesystems/js/OHSApp';
import OHSWidget from '../../../../onehivesystems/js/OHSWidget';
import OHSFilter from '../../../../onehivesystems/js/OHSFilter';
import OHSList, { OHSListDataFormatter } from '../../../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormDataExtractor, OHSFormDataClearer, OHSFormSelectBuilder } from '../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../onehivesystems/js/OHSCRUD';
// Assets
import './Commands.scss';
import { commandModel } from './_variables';
import Command from './Modules/Command';
import InsertableFields from './Modules/InsertableFields';


// COMPONENT
export default function Commands (props) {
   // States and Variables
   const [commands, setCommands] = useState(null);
   const [collections, setCollections] = useState(null);
   const [fields, setFields] = useState(null);
   const [commandPopups, setCommandPopups] = useState({});

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("OnePort | Commands"); // set page title
      getCommands();
      getCollections();
      getFields();
   }, []);

   // Functions
   const getCommands = function () {
      OHSCRUD({
         url: '/v1/oneport/commands',
         method: 'GET',
         success: function (data) {
            setCommands(OHSListDataFormatter(data, commandModel));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const getCollections = function () {
      OHSCRUD({
         url: '/v1/oneport/collections',
         method: 'GET',
         success: function (data) {
            setCollections(OHSListDataFormatter(data));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const getFields = function () {
      OHSCRUD({
         url: '/v1/oneport/fields',
         method: 'GET',
         success: function (data) {
            setFields(OHSListDataFormatter(data));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const addCommand = function () {
      OHSCRUD({
         url: '/v1/oneport/commands',
         method: 'POST',
         payload: OHSFormDataExtractor('oneport-commands-add'),
         success: function (data) {
            if (commands.length > 0) {
               setCommands([...commands, OHSListDataFormatter(data[0], commandModel)]);
            } else {
               setCommands([OHSListDataFormatter(data[0], commandModel)]);
            }
            OHSFormDataClearer('oneport-commands-add');
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }

   // Component
   return (
      <div className="oneport-commands">
         <OHSAppHeader onehive={props.onehive} title="Commands" help="https://www.onehivesystems.com/documentation/oneport/commands" />
         <OHSAppBody onehive={props.onehive}>
            <OHSWidget onehive={props.onehive} id='oneport-commands-add' title="Add a Command" onEnter={addCommand}>
               <OHSFormItem onehive={props.onehive} title="Name">
                  <input type='text' className='ohsinput' data-ohsformdata='name' />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Collection">
                  <OHSFormSelectBuilder onehive={props.onehive} content={collections} field={'name'} blank={false} ohsformdata='collection_id' />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Commands">
                  <textarea className='ohsinput-terminal oneport-command-terminal' data-ohsformdata='commands'></textarea>
               </OHSFormItem>
               <OHSFormSubmit onehive={props.onehive} add={addCommand} clear={() => {OHSFormDataClearer('oneport-commands-add');}} keyListener={true} />
               <InsertableFields onehive={props.onehive} parent={{
                  fields: fields
               }} />
            </OHSWidget>
            <OHSFilter onehive={props.onehive} title="Filter Commands" container='oneport-commands-list' />
            <OHSWidget onehive={props.onehive} id='oneport-commands-list' title="List of Commands">
               <OHSList onehive={props.onehive} content={commands} popups={commandPopups} setPopups={setCommandPopups} template={
                  <Command onehive={props.onehive} parent={{
                     commands: commands,
                     setCommands: setCommands,
                     collections: collections,
                     setCollections: setCollections,
                     fields: fields,
                     setFields: setFields
                  }} />
               } />
            </OHSWidget>
         </OHSAppBody>
         <OHSAppFooter onehive={props.onehive} />
      </div>
   );
}